import { type PaletteOptions } from '@mui/material/styles'
import { staticPalette } from '../static'
import { blue } from './light-blue'
import { dhlRed } from './light-dhl-red'
import { green } from './light-green'
import { grey } from './light-grey'
import { opacity } from './light-opacity'
import { orange } from './light-orange'
import { postYellow } from './light-post-yellow'
import { pure } from './light-pure'
import { red } from './light-red'
import { components } from './components'

export const palettePplLight: PaletteOptions = {
  mode: 'light',
  grey,
  pure,
  static: staticPalette,
  background: {
    default: grey[200],
    paper: pure.light,
    brand: postYellow[600],
  },
  text: {
    primary: grey[800],
    secondary: grey[700],
    tertiary: grey[600],
    disabled: grey[600],
    dhlRed: dhlRed[600],
    error: red[600],
    warning: orange[600],
    success: green[700],
    informative: blue[600],
    inherit: 'inherit',
    placeholder: grey[600],
    /**
     * the icon was removed from material-ui styles in 2016(!), yet the dark theme still has this icon
     * (see https://github.com/mui/material-ui/blob/master/packages/mui-material/src/styles/createPalette.js#L61)
     * for the sake of keeping both themes as much a like as possible, the original icon color was added here;
     */
    icon: 'rgba(0, 0, 0, 0.38)',
  },
  primary: {
    main: dhlRed[600],
    light: dhlRed[100],
    dark: dhlRed[800],
    contrastText: pure.light,
    states: {
      focus: dhlRed[300],
      hover: opacity.primary[80],
    },
    notContained: dhlRed[600],
  },
  secondary: {
    main: postYellow[600],
    light: postYellow[100],
    dark: postYellow[800],
    contrastText: staticPalette.dark,
    states: {
      focus: postYellow[300],
      hover: postYellow[100],
    },
    notContained: postYellow[800],
  },
  dark: {
    main: grey[800],
    light: grey[300],
    dark: grey[900],
    contrastText: pure.light,
    states: {
      focus: grey[400],
      hover: opacity.dark[80],
    },
    notContained: grey[800],
  },
  light: {
    main: pure.light,
    light: pure.light,
    dark: pure.light,
    contrastText: grey[900],
    states: {
      focus: grey[400],
      hover: opacity.light[80],
    },
    notContained: pure.light,
  },
  alternative: {
    main: grey[250],
    light: grey[200],
    dark: grey[400],
    // JIRA-#DS-53 remove when old theme is gone, NOT NOW!
    contrast: pure.dark,
    contrastText: pure.dark,
    states: {
      focus: grey[400],
      hover: opacity.dark[250],
    },
  },
  info: {
    main: blue[600],
    light: blue[100],
    dark: blue[700],
    contrastText: pure.light,
    states: {
      focus: blue[300],
      hover: blue[100],
    },
    notContained: blue[700],
  },
  success: {
    main: green[700],
    dark: green[900],
    light: green[100],
    contrastText: pure.light,
    states: {
      focus: green[300],
      hover: green[100],
    },
    notContained: green[800],
  },
  warning: {
    main: orange[700],
    dark: orange[900],
    light: orange[100],
    contrastText: pure.light,
    states: {
      focus: orange[400],
      hover: orange[100],
    },
    notContained: orange[900],
  },
  error: {
    main: red[600],
    dark: red[700],
    light: red[100],
    contrastText: pure.light,
    states: {
      focus: red[300],
      hover: red[100],
    },
    notContained: red[700],
  },
  components,

  // START overrule some items already in MUI (so we do not have to do this in components)
  action: {
    disabled: opacity.dark[250],
    disabledBackground: opacity.dark[50],
    disabledOpacity: 1,
    hover: opacity.dark[50],
  },
  divider: grey[300],
  // END overrule some items already in MUI (so we do not have to do this in components)
}
